import TripTravellerAllocationPassenger from './trip-traveller-allocation-passenger-component';
import TripTravellerAllocationPassengerService from './trip-traveller-allocation-passenger-service';

import './trip-traveller-allocation-passenger.scss';

const MODULE_NAME = 'app.trip.traveller-allocation.passenger';
const module = angular.module(MODULE_NAME, [])
    .directive(TripTravellerAllocationPassenger.DIRECTIVE_NAME, TripTravellerAllocationPassenger)
    .service('tripTravellerAllocationPassengerService', TripTravellerAllocationPassengerService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/checkout/trip-traveller-allocation/trip-traveller-allocation-segment/trip-traveller-allocation-flight/trip-traveller-allocation-passenger/trip-traveller-allocation-passenger-module.js